<template>
  <v-app id="loginapp">
    <v-content>
      <v-container fluid fill-height="">
        <v-layout row align-center justify-center>
          <v-flex xs12 md6 sm8 lg4>
            <v-card class="elevation-0">
              <a href="/">
                <v-img src="../../../static/img/logo.png" height="200" contain>
                </v-img>
              </a>
              <v-card-title primary-title>
                <div>
                  <div style="font-size: 30px" class="headline">
                    {{ getString("Pagina di accesso") }}
                  </div>
                  <span class="grey--text">{{
                    getString(
                      "Inserisci i tuoi dati per accedere al portale amministrativo"
                    )
                  }}</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :disabled="sending"
                  @keydown.enter="$refs.pwdfa.focus()"
                  type="email"
                  name="user"
                  color="#212121"
                  solo
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  v-bind:hint="
                    getString(
                      'Il campo deve essere un indirizzo email valido, per esempio: elcarro@carriage.xyz'
                    )
                  "
                  required
                ></v-text-field>

                <v-text-field
                  :append-icon="
                    toggleShowPassword ? 'visibility' : 'visibility_off'
                  "
                  @click:append="toggleShowPassword"
                  ref="pwdfa"
                  :disabled="sending"
                  @keydown.enter="login"
                  :type="showPassword ? 'text' : 'password'"
                  name="password"
                  color="#212121"
                  solo
                  v-model="password"
                  label="Password"
                  v-bind:hint="
                    getString(
                      'La tua password, se non la ricordi recuperala qui sotto'
                    )
                  "
                  required
                ></v-text-field>

                <label
                  v-html="
                    getString(
                      `Questo aumenterà sensibilmente il tuo tempo di sessione.`
                    )
                  "
                ></label>
                <v-checkbox
                  :disabled="sending"
                  :label="getString('Ricordami')"
                  v-model="remember"
                ></v-checkbox>
              </v-card-text>
              <v-card-actions>
                <v-btn flat @click="show = !show" class="q-orange">{{
                  getString("Recupera la password")
                }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  :disabled="sending"
                  class="q-orange"
                  @click="login"
                  >{{ getString("Accedi") }}</v-btn
                >
              </v-card-actions>
              <v-progress-linear
                indeterminate
                active
                v-if="isLoading"
                color="red lighten-2"
              ></v-progress-linear>
              <v-slide-y-transition>
                <div v-show="show">
                  <v-card-text>
                    <span class="grey--text">{{
                      getString(
                        "Inserisci la tua email per recuperare la password"
                      )
                    }}</span>
                    <v-text-field
                      color="#212121"
                      :disabled="sending"
                      solo
                      v-model="recEmail"
                      :rules="emailRules"
                      label="E-mail"
                      v-bind:hint="
                        getString(
                          'Il campo deve essere un indirizzo email valido, per esempio: elcarro@carriage.xyz'
                        )
                      "
                      required
                    ></v-text-field>
                  </v-card-text>
                  <v-btn
                    :disabled="sending"
                    flat
                    @click="recovery"
                    class="q-orange"
                    >{{ getString("Recupera") }}</v-btn
                  >
                </div>
              </v-slide-y-transition>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="alert"
      bottom
      multi-line
      right
      :timeout="0"
      color="red darken-4"
    >
      {{ alertText }}
      <v-btn class="q-text-whitesmoke" flat @click="alert = false">
        {{ getString("Chiudi") }}
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="alertSuccess"
      bottom
      multi-line
      right
      :timeout="dyncamicAlertTime"
      color="green lighten-1"
    >
      {{ alertTextSuccess }}
      <v-btn class="q-text-whitesmoke" flat @click="alertSuccess = false">
        {{ getString("Chiudi") }}
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import ajax from "../../ajax";
import Utils from "../../utils";
var ut = new Utils();
export default {
  name: "Login",
  mounted: function () {
    let message = this.$route.query.msg;
    if (message !== undefined) {
      this.showAlert(message);
    }
    message = this.$route.query.imsg;
    if (message !== undefined) {
      this.showAlertSuccess(message);
    }
    if (this.$store.getters.isLogged) {
      this.$router.push("/admin/dashboard");
    }
  },
  computed: {
    dyncamicAlertTime: function () {
      let t = this.alertText.length * 100;
      return t > 3000 ? t : 3000;
    },
    emailRules: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
  },
  data: () => {
    return {
      show: false,
      email: "",
      recEmail: "",
      password: "",
      alert: false,
      alertSuccess: false,
      alertText: "",
      alertTextSuccess: "",
      remember: false,
      sending: false,
      error: "",
      isLoading: false,
      showPassword: false,
    };
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword; // Metodo per invertire lo stato della password (mostrata o nascosta)
    },
    showAlertSuccess: function (text) {
      this.alertTextSuccess = text;
      this.alertSuccess = !this.alert;
    },
    showAlert: function (text) {
      this.alertText = text;
      this.alert = !this.alert;
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    login: function () {
      let self = this;
      self.isLoading = true;
      if (!ut.ValidateEmail(this.email)) {
        this.showAlert("Email non valida");
        return;
      }
      if (this.password === "") {
        this.showAlert("Password vuota");
        return;
      }
      this.sending = true;
      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/user/login",
          // params
          {
            email: this.email,
            password: this.password,
            remember: this.remember ? "ok" : null,
          }
        )
        .then(function (response) {
          self.isLoading = false;
          self.$store.commit("setToken", response.data.data.token);
          self.$router.push("/admin/dashboard");
        })
        .catch(function (error) {
          self.isLoading = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            self.showAlert(error.response.data.errorMessage);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
          } else {
            // Something happened in setting up the request that triggered an Error
          }
          self.sending = false;
        });
    },
    recovery: function () {
      this.sending = true;
      if (ut.ValidateEmail(this.recEmail)) {
        let self = this;
        self.isLoading = true;
        ajax.axios
          .get(ajax.baseUrl() + "/admin/user/recovery/" + this.recEmail)
          .then(function (response) {
            self.sending = false;
            self.showAlertSuccess(response.data.data);
            self.recEmail = "";
            self.isLoading = false;
          })
          .catch(function (error) {
            // handle error
            self.sending = false;
            self.showAlert(error.response.data.errorMessage);
            self.recEmail = "";
            self.isLoading = false;
          });
      } else {
        this.showAlert(this.getString("Email non valida"));
      }
    },
  },
};
</script>

<style scoped>
#loginapp {
  background: 3% bottom url("../../../static/img/quadrato.png") no-repeat;
  background-size: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Login.vue